import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import ReactSelect from 'react-select';
import { components } from '../../Utils/ReactSelectComponents';
import { getMyOwnDataById, updateLotStore, saveLot } from '../../../store/actions/negotiationLot/negotiationLotActions';
import { refreshSubLotIDs, pushNewEmptySubLot } from '../../../store/actions/NegotiationSubLot/negotiationSubLotActions';
import { addOptionalsBySubLot } from '../../../store/actions/carOptionals/carOptionalsActions';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import InputLabel from '@material-ui/core/InputLabel';
import NewIcon from '@material-ui/icons/CreateNewFolder';
import ReturnIcon from '@material-ui/icons/ArrowBack';
import SaveIcon from '@material-ui/icons/Save';
import CancellationIcon from '@material-ui/icons/DeleteForever';
import ClosingIcon from '@material-ui/icons/Lock';
import CopyIcon from '../../../Icons/baselineFileCopy.svg';
import NegotiationLotAPI from '../../../API/NegotiationLotsAPI';
import DropdownListAPI from '../../../API/DropdownListAPI';
import OptionalsAPI from '../../../API/OptionalsAPI';
import FileManagementAPI from '../../../API/FileManagementAPI';
import NegotiationSubLotExpansionPanel from './NegotiationSubLotExpansionPanel';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import NegotiationCancellationDialog from './NegotiationCancellationDialog';
import LinearProgress from '../../Utils/LinearProgress';
import { handleServerError, handleSpecialCharacters } from '../../../Utils/Helper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import AttachFile from '@material-ui/icons/AttachFile';
import Inbox from '@material-ui/icons/Inbox';
import FileDownload from '@material-ui/icons/VerticalAlignBottom';
import { FormatDateDocument, ConvertFromBool } from '../../Utils/GenericFunctions';
import { FP_NEGOTIATION_GROUP, NEGOTIATION_PHASE } from '../../../Utils/Constants';
import * as md5 from 'md5';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import MaskedInput from 'react-text-mask';


const styles = theme => ({
  width100: {
    width: '100%',
  },
  height100: {
    height: '100%',
  },
  paperL1: {
    padding: '120px 32px 12px',
    color: theme.palette.text.secondary
  },
  textBlack: {
    color: '#000000'
  },
  flex: {
    flex: 1
  },
  group: {
    display: 'inline-block'
  },
  carModelPaper: {
    padding: '0px 32px',
    backgroundColor: theme.palette.primary.light
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  appBar: {
    backgroundColor: '#F6F6F6'
  },
  alignText: {
    marginTop: '6px'
  },
  toolbarHeight: {
    minHeight: '52px'
  },
  tblRowHeight: {
    height: '36px'
  },
  txtCenter: {
    textAlign: 'center'
  },
  //DON'T REMOVE (Used in ReactSelectComponents)
  noOptionsMessage: {
    padding: `${theme.spacing.unit / 2}px`
  },
  input: {
    display: 'flex',
    padding: 0
  }
});

function InputNumber(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      fixedDecimalScale
      decimalScale={0}
      maxLength={4}
    />
  );
}
InputNumber.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('dd/mm/yyyy', { maxYear: new Date().getFullYear() });

const DateMask = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={' '}
    />
  );
}
DateMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
};


class NegotiationLotSummary extends React.Component {
  dataAPI;
  dropdownListAPI;
  optionalsAPI;
  filesAPI;

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openDialog: false,
      openCancellationDialog: false,
      loading: true,
      success: false,
      subLotsAppend: [],
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      changedValueDetected: false,
      openError: false,
      openSuccess: false,
      alertMessage: '',
      saveClickDetected: false,
      lotPhase: 'Negotiation',
      saleChannelData: [],
      optionalsData: [],
      rappelData: [],
      colorData: [],
      lpGainData: [],
      documentsTable: () => { },
      autoHideDuration: 0,
      path: '',
      documents: []
    }
    this.dataAPI = new NegotiationLotAPI();
    this.dropdownListAPI = new DropdownListAPI();
    this.optionalsAPI = new OptionalsAPI();
    this.filesAPI = new FileManagementAPI();
  }

  componentDidMount() {
    Promise.all([this.dropdownListAPI.getAllSalesChannels(), this.optionalsAPI.getAllOptionals(), this.dropdownListAPI.getAllRappelTypes(), this.dropdownListAPI.getAllColors(), this.dropdownListAPI.getAllLPGains()]).then((response) => {
      this.setState({
        saleChannelData: response[0].data,
        optionalsData: response[1].data,
        rappelData: response[2].data,
        colorData: response[3].data,
        lpGainData: response[4].data,
        loading: false
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      });
    });
  };

  handleGoBack = () => {
    if (this.state.changedValueDetected === true && this.state.saveClickDetected === false) {
      this.setState({
        openDialog: true,
        confirmationQuestion: 'Tem a certeza que pretende RETROCEDER sem guardar as alterações?',
        confirmationMessage: 'A informação relativamente às alterações executadas será perdida.',
        confirmationFunction: this.handleClose,
        cancelFunction: this.handleCloseDialog
      });
    }
    else {
      this.handleClose();
    }
  };

  handleClose = () => {
    this.props.handleClose();
  };

  handleCloseDialog = () => {
    const formData = new FormData();
    formData.delete('documento');
    this.setState({
      openDialog: false,
      loading: false,
      success: false
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      openSuccess: false,
      alertMessage: ''
    });
  };

  handleCloseCancellationDialog = () => {
    this.setState({ openCancellationDialog: false });
  };

  handleClickUpload = () => {
    this.setState({
      openDialog: true,
      loading: false,
      success: false,
      confirmationQuestion: 'ANEXAR DOCUMENTO',
      confirmationMessage: this.uploadFileForm(),
      confirmationFunction: () => this.handleClickUploadFile(),
      cancelFunction: this.handleCloseDialog,
    })
  };

  handleClickUploadFile = () => {
    const formData = new FormData();
    this.setState({ loading: true })
    let lotFile = document.querySelector('#file');
    formData.append('documento', lotFile.files[0]);
    this.filesAPI.uploadFileByLotId(this.props.myLotData.L1ID, formData).then((success) => {
      this.setState({
        loading: false,
        success: true,
        openSuccess: true,
        autoHideDuration: 3000,
        alertMessage: 'Resultado do pedido: ' + success.data
      })
      this.handleCloseDialog();
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openDialog: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseDialog();
    });
  };

  handleClickSelectFile = () => {
    document.querySelector('#file').click();
  };

  handleChangeSubmitFile = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleClickGetFiles = () => {
    this.filesAPI.getFilesByLotId(this.props.myLotData.L1ID).then(success => {
      let variable1 = success.data.replace('\\"', '');
      if (variable1.indexOf('Error') > -1) {
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: variable1
        });
      } else {
        var pos = variable1.indexOf(', status');
        var str = variable1.substring(1, pos);
        var str1 = str.replace('data=', '"data":')
        let jsonData = JSON.parse("{" + str1 + "}");
        this.setState({
          documents: jsonData.data
        });
        this.setState({
          openDialog: true,
          confirmationQuestion: 'DOCUMENTOS',
          confirmationMessage: this.lotFilesTable(),
          confirmationFunction: this.handleCloseDialog,
          cancelFunction: this.handleCloseDialog
        });
      }
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleClickDownload = (fileID) => {
    this.setState({ loading: true })
    let token = this.createFileToken();
    this.filesAPI.downloadFile(fileID, token).then(success => {
      let fileUrl = success.data;
      window.open(fileUrl, '_blank');
      this.setState({
        loading: false
      })
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  createFileToken = () => {
    let today = new Date();
    let todayDay = today.getDate();
    let todayMonth = today.getMonth() + 1;
    let todayYear = today.getFullYear();

    if (todayDay < 10) todayDay = '0' + todayDay;
    if (todayMonth < 10) todayMonth = '0' + todayMonth;

    let tokenBasic = todayYear + 'DocLotes' + todayMonth + 'LPPT' + todayDay
    let token = md5(tokenBasic);

    return token;
  };

  handleClickDuplicate = () => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende DUPLICAR o Lote em Negociação?',
      confirmationMessage: 'A informação referente ao lote e respetivo sublote será replicada e criado um novo lote contendo as mesmas informações.',
      confirmationFunction: this.handleSubmitDuplicate,
      cancelFunction: this.handleCloseDialog
    });
  };

  handleSubmitDuplicate = () => {
    this.setState({ loading: true })
    this.dataAPI.duplicateNegotiationLot(this.props.negotiationLot.L1ID).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.handleCloseDialog()
        this.handleClose()
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseDialog()
    });
  };

  handleClickCancellation = () => {
    this.setState({
      openCancellationDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende CANCELAR o Lote em Negociação?',
      confirmationMessage: 'A negociação do lote será cancelada. A informação contida no mesmo passará a estar disponível apenas no histórico de lotes negociados. Abaixo pode inserir uma observação relativamente ao cancelamento.',
      confirmationFunction: this.handleSubmitCancel,
      cancelFunction: this.handleCloseCancellationDialog
    });
  };

  handleSubmitCancel = (lotCancellationObs) => {
    this.setState({ loading: true })
    this.dataAPI.cancelNegotiationLot(this.props.negotiationLot.L1ID, lotCancellationObs).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.handleCloseCancellationDialog()
        this.handleClose()
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseCancellationDialog()
    });
  };

  handleClickClosing = () => {
    this.props.saveLot().then(() => {
      this.dataAPI.getLotById(this.props.myLotData.L1ID).then((response) => {
        this.setState({
          openDialog: true,
          confirmationQuestion: 'Tem a certeza que pretende FECHAR o Lote em Negociação?',
          confirmationMessage: 'A negociação do lote da marca ' + this.props.myLotData.Brand + ', modelo ' + this.props.myLotData.Model + ' e quantidade ' + response.data.TotalSubLotQuantity +
            ' será fechada passando o mesmo a estar disponível para o departamento de Compras Firmes. A sua informação passará a estar presente no histórico de lotes negociados.',
          confirmationFunction: this.handleSubmitFirmPurchase,
          cancelFunction: this.handleCloseDialog
        });
      }).catch((error) => {
        this.setState({
          loading: false,
          success: false,
          openDialog: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      });
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openDialog: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleSubmitFirmPurchase = () => {
    this.setState({ loading: true })
    this.props.saveLot().then(() => {
      this.dataAPI.finishNegotiationLot(this.props.negotiationLot.L1ID).then((response) => {
        this.setState({
          loading: false,
          success: true
        });
        setTimeout(() => {
          this.handleCloseDialog()
          this.handleClose()
        }, 500)
      }).catch((error) => {
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
        this.handleCloseDialog();
      });
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseDialog()
    });
  };

  handleClickEdit = () => {
    this.setState({
      saveClickDetected: true,
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende GUARDAR a informação do Lote em Negociação?',
      confirmationMessage: 'As informações inseridas ou alteradas relativas ao lote e respetivo sublote serão guardadas não sendo possível retroceder ou visualizar o estado anterior das mesmas.',
      confirmationFunction: this.handleSubmitEdit,
      cancelFunction: this.handleCloseDialog
    });
  };

  handleSubmitEdit = () => {
    this.setState({ loading: true });
    this.props.saveLot().then((response) => {
      this.setState({
        loading: false,
        success: true,
        changedValueDetected: false
      });
      this.props.refreshSubLotIDs(response.data, this.props.negotiationLot.L1ID);
      this.handleCloseDialog();
      this.props.reloadTable();
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseDialog()
    });
  };

  handleClickNewL2() {
    let nColdSubLotId = this.props.pushNewEmptySubLot();
    this.props.addOptionalsBySubLot(nColdSubLotId, []);
    this.setState({
      openSuccess: true,
      alertMessage: 'Novo sublote criado',
      autoHideDuration: 2000
    })
    setTimeout(() => {
      let lastLoteId = document.getElementById('subLot' + nColdSubLotId);
      if (lastLoteId)
        lastLoteId.scrollIntoView()
    }, 500)
  };

  handleChangeInputForm = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleChange = propName => event => {
    this.props.updateLotStore(propName, handleSpecialCharacters(event.target.value));
    this.detectChange();
  };

  handleChangeSelect = name => value => {
    this.props.updateLotStore([name], value);
    this.detectChange();
  };

  detectChange = () => {
    this.setState({ changedValueDetected: true });
  };

  undetectChange = () => {
    this.setState({ changedValueDetected: false });
  };

  uploadFileForm = () => {
    const { classes } = this.props;
    return (
      <div className={classes.txtCenter}>
        <Button id='selectFile' variant='contained' color='primary' type='submit' onClick={this.handleClickSelectFile}>
          Selecionar documento
        </Button>
      </div>
    );
  };

  lotFilesTable = () => {
    const { classes } = this.props;
    return (
      <div>
        <Table>
          <TableHead>
            <TableRow className={classes.tblRowHeight}>
              <TableCell padding='none'>Nome Documento</TableCell>
              <TableCell padding='none'>Tipo Documento</TableCell>
              <TableCell padding='none'>Data</TableCell>
              <TableCell padding='none'> </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.documents.map(doc => (
              <TableRow key={doc.Arquivo} className={classes.tblRowHeight}>
                <TableCell padding='none' component='th' scope='row'>
                  {doc.NomeDocumento}
                </TableCell>
                <TableCell padding='none' component='th' scope='row'>
                  {doc.TipodeDocumento}
                </TableCell>
                <TableCell padding='none' component='th' scope='row'>
                  {FormatDateDocument(doc.Data)}
                </TableCell>
                <TableCell padding='none' component='th' scope='row'>
                  <Tooltip title='Ver Documento' placement='bottom' >
                    <IconButton className={classes.buttonSize} onClick={() => { this.handleClickDownload(doc.Arquivo) }}>
                      <FileDownload />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    )
  };

  render() {
    const { classes } = this.props;
    let subLots = [];
    if (this.props.negotiationSubLots) {
      let myObject = this.props.negotiationSubLots;
      for (var key in myObject) {
        if (myObject.hasOwnProperty(key)) {

          subLots.push(
            <NegotiationSubLotExpansionPanel
              key={key}
              subLotId={key}
              handleClose={this.handleClose.bind(this)}
              detectChange={this.detectChange.bind(this)}
              undetectChange={this.undetectChange.bind(this)}
              optionalsData={this.state.optionalsData}
              estadoId={this.props.myLotData.EstadoID}
              reloadTable={this.props.reloadTable.bind(this)}
              lotPhase={this.state.lotPhase}
              rappelData={this.state.rappelData}
              colorData={this.state.colorData}
              lpGainData={this.state.lpGainData}
            />
          );

        }
      }
    }

    return (
      <div>
        <AppBar className={classes.appBar}>

          <Toolbar className={classes.toolbarHeight} >
            <Tooltip title='Retroceder' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleGoBack.bind(this)}>
                <ReturnIcon />
              </Button>
            </Tooltip>
            <Typography variant='title' className={classNames(classes.flex, classes.textBlack)}>
              LOTE EM NEGOCIAÇÃO
            </Typography>
            <Tooltip title='Anexar Documento' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickUpload}
                disabled={this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0}>
                <AttachFile />
              </Button>
            </Tooltip>
            <Tooltip title='Documentos' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickGetFiles}
                disabled={this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0}>
                <Inbox />
              </Button>
            </Tooltip>
            <div>
              <input style={{ display: 'none' }} type='file' id='file' name='file' accept='.xls, .xlsx, .doc, .docx, .mml, .gif, .png, .pdf' onChange={this.handleChangeSubmitFile('path')} />
            </div>
            <Tooltip title='Duplicar Lote' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickDuplicate}
                disabled={this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0}>
                <img src={CopyIcon} alt='Copiar' className={classes.iconSize} />
              </Button>
            </Tooltip>
            <Tooltip title='Cancelar Negociação' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickCancellation}
                disabled={this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0}>
                <CancellationIcon />
              </Button>
            </Tooltip>
            <Tooltip title='Fechar Negociação' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickClosing}
                disabled={this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0}>
                <ClosingIcon />
              </Button>
            </Tooltip>
            <Tooltip title='Guardar' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickEdit}
                disabled={this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0}>
                <SaveIcon />
              </Button>
            </Tooltip>
          </Toolbar>

          <Paper className={classes.carModelPaper}>
            <Grid container spacing={8}>
              <Grid item xs={12} sm={4}>
                <TextField
                  id='brand'
                  label='MARCA'
                  margin='dense'
                  fullWidth
                  InputProps={{ readOnly: true }}
                  value={this.props.negotiationLot.Brand}
                />
              </Grid>
              <Grid item xs={12} sm={7}>
                <TextField
                  id='model'
                  label='MODELO'
                  margin='dense'
                  fullWidth
                  InputProps={{ readOnly: true }}
                  value={this.props.negotiationLot.Model}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Grid container justify='center' alignItems='center'>
                  <Tooltip title='Novo Sublote' placement='bottom' >
                    <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => { this.handleClickNewL2() }}
                      disabled={this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0}>
                      <NewIcon />
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
          {this.state.loading ? <LinearProgress /> : null}

        </AppBar>
        <Paper className={classes.paperL1}>

          <Grid container spacing={8}>

            <Grid item xs={12} sm={6}>
              {this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0 ?
                <TextField
                  id='saleChannels'
                  label='CANAL DE VENDA'
                  multiline
                  fullWidth
                  InputProps={{ readOnly: true }}
                  value={this.props.myLotData.SaleChannel.join(' || ')}
                />
                :
                <Grid container justify='center'>
                  <div className={classes.width100}>
                    <InputLabel htmlFor='SaleChannelDDL'>
                      CANAL DE VENDA
                    </InputLabel>
                    <ReactSelect
                      classes={classes}
                      options={this.state.saleChannelData}
                      components={components}
                      value={this.props.myLotData.SaleChannelDDL}
                      onChange={this.handleChangeSelect('SaleChannelDDL')}
                      placeholder=''
                      isMulti
                      closeMenuOnSelect={false}
                    />
                  </div>
                </Grid>
              }
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                id='deliveryDeadline'
                label='PRAZO DE ENTREGA (dias úteis)'
                fullWidth
                className={this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0 ? '' : classes.alignText}
                value={this.props.myLotData.DeliveryDeadline}
                onChange={this.handleChange('DeliveryDeadline')}
                InputProps={{ readOnly: this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0, inputComponent: InputNumber }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                id='licensePlatePlan'
                label='PLANO DE MATRÍCULAS'
                fullWidth
                inputProps={{ readOnly: this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0, maxLength: 50 }}
                value={this.props.myLotData.LicensePlatePlan}
                onChange={this.handleChange('LicensePlatePlan')}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                id='vehicleLocation'
                label='LOCALIZAÇÃO VEÍCULOS'
                fullWidth
                inputProps={{ readOnly: this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0, maxLength: 200 }}
                value={this.props.myLotData.VehicleLocation}
                onChange={this.handleChange('VehicleLocation')}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                id='lotLPPT'
                label='LOTE LPPT'
                fullWidth
                inputProps={{ readOnly: this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0, maxLength: 200 }}
                value={this.props.myLotData.LotLPPT}
                onChange={this.handleChange('LotLPPT')}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                id='formalizationDate'
                label='DATA FORMALIZAÇÃO (dd/mm/aaaa)'
                fullWidth
                type='text'
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  inputComponent: DateMask,
                  value: this.props.myLotData.FormalizationDate,
                  pipe: autoCorrectedDatePipe,
                  placeholder: '',
                  onChange: this.handleChange('FormalizationDate'),
                  guide: false,
                  readOnly: this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={8} justify='flex-start' alignItems='center' className={classes.inputArea} >
                <Grid item>
                  <FormLabel component='legend'>
                    AQUISIÇÃO C/ A1:
                  </FormLabel>
                </Grid>
                <Grid item>
                  <FormControl component='fieldset' >
                    <RadioGroup
                      aria-label='acquisitionA1'
                      name='acquisitionA1'
                      className={classes.group}
                      inputprops={{ readOnly: this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0 }}
                      value={ConvertFromBool(this.props.myLotData.WithA1)}
                      onChange={this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0 ? null : this.handleChange('WithA1')}
                    >
                      <FormControlLabel name='yes' value='yes' control={<Radio disableRipple={this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0} color='primary' />} label='Sim' />
                      <FormControlLabel name='no' value='no' control={<Radio disableRipple={this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0} color='primary' />} label='Não' />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={8} justify='flex-start' alignItems='center' className={classes.inputArea} >
                <Grid item>
                  <FormLabel component='legend'>
                    VALOR DEBITADO:
                  </FormLabel>
                </Grid>
                <Grid item>
                  <FormControl component='fieldset'>
                    <RadioGroup
                      aria-label='amountDebited'
                      name='amountDebited'
                      className={classes.group}
                      inputprops={{ readOnly: this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0 }}
                      value={ConvertFromBool(this.props.myLotData.AmountDebited)}
                      onChange={this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0 ? null : this.handleChange('AmountDebited')}
                    >
                      <FormControlLabel name='yes' value='yes' control={<Radio disableRipple={this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0} color='primary' />} label='Sim' />
                      <FormControlLabel name='no' value='no' control={<Radio disableRipple={this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0} color='primary' />} label='Não' />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                id='lotObs'
                label='OBSERVAÇÕES'
                fullWidth
                multiline
                rows='1'
                rowsMax='3'
                inputProps={{ readOnly: this.props.myLotData.EstadoID !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(FP_NEGOTIATION_GROUP) < 0, maxLength: 1000 }}
                value={this.props.myLotData.Observations}
                onChange={this.handleChange('Observations')}
              />
            </Grid>

          </Grid>

        </Paper>

        <div className={classes.width100}>
          {(subLots.length > 0) ? subLots : <NegotiationSubLotExpansionPanel subLotId={0} />}
          <br />
        </div>

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}>
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleClose.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <Dialog
          open={this.state.openCancellationDialog}
          onClose={this.handleCloseCancellationDialog}
        >
          <NegotiationCancellationDialog
            openCancellationDialog={this.state.openCancellationDialog}
            handleClose={this.handleClose.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <SnackbarAlert openSuccess={this.state.openSuccess} openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} autoHideDuration={this.state.autoHideDuration} />

      </div>
    );
  }
}

NegotiationLotSummary.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    myLotData: getMyOwnDataById(state, ownProps.nLotId),
    ...state
  }
};

const mapDispatchToProps = dispatch => ({
  saveLot: () => dispatch(saveLot()),
  updateLotStore: (propName, propValue, nLotId) => dispatch(updateLotStore(propName, propValue, nLotId)),
  pushNewEmptySubLot: () => dispatch(pushNewEmptySubLot()),
  addOptionalsBySubLot: (nColdSubLotId, aOptionals) => dispatch(addOptionalsBySubLot(nColdSubLotId, aOptionals)),
  refreshSubLotIDs: (oColdToHotSubLotIdMap, lotId) => dispatch(refreshSubLotIDs(oColdToHotSubLotIdMap, lotId))
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NegotiationLotSummary));


// WEBPACK FOOTER //
// ./src/components/Negotiation/EditLots/NegotiationLotSummary.js